import { scalePoint, scaleLinear } from 'd3-scale';

export function lineChartScale({
  getConfiguration,
  meta,
  data,
  width,
  height,
}) {
  let labels, numbers;

  const barLabels = data.map(bar => bar.row_label);

  labels = scalePoint().domain(barLabels).range([0, width]);
  labels.hasTextLabels = true;

  let barValues = data
    .map(bar => Object.values(bar).filter(val => typeof val === 'number'))
    .flat();

  const minValue = getConfiguration('minValue', Math.min(0, ...barValues));
  const maxValue = getConfiguration('maxValue', Math.max(...barValues));

  numbers = scaleLinear().rangeRound([height, 0]).domain([minValue, maxValue]);

  return {
    x: labels,
    y: numbers,
  };
}
